/**
 * ProcessingOrb Component
 * 
 * Full-size processing orb with four-layer "living energy" effect.
 * Used for main processing states (recording upload, note generation).
 */

import React from 'react';

interface ProcessingOrbProps {
    /** Diameter in pixels */
    size?: number;
    /** Additional CSS classes */
    className?: string;
}

export function ProcessingOrb({ size = 100, className = '' }: ProcessingOrbProps) {
    return (
        <div
            className={`processing-orb ${className}`}
            style={{ width: size, height: size }}
            role="status"
            aria-label="Processing in progress"
        >
            {/* Layer 1: Background Glow */}
            <div className="orb-glow" />

            {/* Layer 2: Core Body */}
            <div className="orb-core" />

            {/* Layer 3: Rotating Energy */}
            <div className="orb-energy" />

            {/* Layer 4: Sharp Ring Edge */}
            <div className="orb-ring" />
        </div>
    );
}
